import React from 'react';
import brasaoImg from '../assets/images/brasao.png';

type AppOfflineProps = {
  mensagem: string;
};

const AppOffline: React.FC<AppOfflineProps> = ({ mensagem }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        padding: 24,
        boxSizing: 'border-box',
        textAlign: 'center',
      }}
    >
      <img
        src={brasaoImg}
        alt="Prefeitura de Anastácio"
        style={{ maxWidth: 180, width: '100%', height: 'auto', marginBottom: 24 }}
      />
      <p
        style={{
          maxWidth: 480,
          margin: 0,
          color: '#333',
          fontSize: '1.125rem',
          lineHeight: 1.5,
          whiteSpace: 'pre-wrap',
        }}
      >
        {mensagem}
      </p>
    </div>
  );
};

export default AppOffline;
